import { useEffect } from "react";

export const useInitDocumentTitle = () => {
  useEffect(() => {
    if (document.head.querySelectorAll("title").length === 0) {
      document.title = "";
    }
  }, []);
};
